import React, { useState, useEffect } from 'react';
import { Button, Grid, Paper, Alert, CircularProgress } from "@mui/material";
import './LoginPage.css';
import { useAuth, extractTokensFromURL, exchangeLoginCode } from '../../contexts/AuthContext';
import { persistDomainsList } from '../../utils/domainStorage';

const LoginPage = () => {
  const { handleLogin, backendURL } = useAuth();

  const [openAlert, setOpenAlert] = useState(false);
  const [isProcessing, setIsProcessing] = useState(true);

  useEffect(() => {
    checkAuthentication();
  }, []);

  const checkAuthentication = async () => {
    try {
      await exchangeLoginCode(backendURL);
      const storedToken = extractTokensFromURL();
      const storedGraphToken = sessionStorage.getItem('graph_token');
      const storedRefreshToken = sessionStorage.getItem('refresh_token');

      const headers = { 'X-Requested-With': 'XMLHttpRequest' };
      if (storedToken) {
        headers['Authorization'] = `Bearer ${storedToken}`;
      }
      if (storedGraphToken) {
        headers['X-Graph-Token'] = storedGraphToken;
      }
      if (storedRefreshToken) {
        headers['X-Refresh-Token'] = storedRefreshToken;
      }

      const response = await fetch(`${backendURL}/api/protected/`, {
        method: "GET",
        credentials: "include", // Sends HttpOnly cookie automatically
        headers
      });

      if (!response.ok) {
        throw new Error("Not authenticated");
      }

      const data = await response.json();

      persistDomainsList(data.domains_list);

      localStorage.setItem("sr_id", data.user.sr_id);

      handleLogin({
        fullname: data.user.name,
        email: data.user.preferred_name,
        role: data.user.role,
      });
    } catch (error) {
      console.error("Authentication failed:", error);
      // Arriving without a session is normal; only flag a failed redirect login.
      setOpenAlert(Boolean(sessionStorage.getItem('access_token')));
    } finally {
      setIsProcessing(false);
    }
  };

  const handleSubmit = () => {
    // Optional: Clear any cached application data
    localStorage.removeItem("domains");
    localStorage.removeItem("sr_id");

    // Redirect to backend SSO login
    window.location.href = `${backendURL}/api/auth/login/`;
  };

  if (isProcessing) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  return (
    <div>
      <div className="login-form-container">
        <Grid className="form-container">
          <Grid item xs={10} sm={8} md={6} lg={4}>
            <Paper
              elevation={0}
              style={{
                textAlign: "center",
                backgroundColor: "transparent",
              }}
            >
              <p className="greeting">
                Hello, Welcome to Agri-Intel
              </p>

              <Button
                variant="contained"
                color="primary"
                fullWidth
                size="large"
                className="custom-button"
                onClick={handleSubmit}
              >
                Sign-in with SSO
              </Button>

              {openAlert && (
                <Alert
                  severity="error"
                  onClose={() => setOpenAlert(false)}
                  sx={{ marginTop: 2 }}
                >
                  Failed to login. Please try again.
                </Alert>
              )}
            </Paper>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default LoginPage;